import { TOptions } from '../../types/options';

import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TGetPeriodsSucceed, EPeriodsActionTypes } from './types';

export const getPeriodsSucceed: (periods: TOptions[]) => TGetPeriodsSucceed = actionGenerator<
  EPeriodsActionTypes.Succeed,
  TOptions[]
>(EPeriodsActionTypes.Succeed);
